var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon07(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 30,
    viewBox: "0 0 30 30",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#ED1C24",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.63 18.167h-.942c-.802 0-1.452.65-1.452 1.462v.325a1.456 1.456 0 1 1-2.914 0v-.325c0-.812-.661-1.462-1.463-1.462-.801 0-1.451.65-1.451 1.462v.325a1.463 1.463 0 0 1-2.925 0v-.325c0-.812-.65-1.462-1.452-1.462-.802 0-1.463.65-1.463 1.462v.325a1.456 1.456 0 1 1-2.914 0v-.347c0-.801-.639-1.451-1.43-1.462h-.856v-1.062c0-1.495 1.127-2.762 2.655-3.13.303-.076.617-.12.953-.12h12.047c.335 0 .65.044.953.12 1.527.368 2.654 1.635 2.654 3.13v1.084zM21.977 12.295a4.66 4.66 0 0 0-.953-.087H8.977c-.325 0-.639.033-.953.098v-1.538c0-1.3 1.17-2.351 2.622-2.351h8.71c1.451 0 2.621 1.05 2.621 2.35v1.528z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.48 8.426h-.835c-.282 0-.542.032-.79.097V6.844c0-.379.367-.704.812-.704.444 0 .812.325.812.704v1.582zM20.146 8.523a2.684 2.684 0 0 0-.791-.108h-.834v-1.81c0-.444.368-.812.812-.812.445 0 .813.368.813.812v1.918zM15.813 8.417h-1.626V6.055c0-.488.369-.888.813-.888.444 0 .813.4.813.888v2.362zM25.02 26.834H4.98a.818.818 0 0 1-.813-.813c0-.444.368-.812.812-.812h.39V19.77h.661v.075c0 1.452.953 2.795 2.372 3.11a3.057 3.057 0 0 0 2.871-.802 1.06 1.06 0 0 1 1.495-.011c.564.553 1.333.9 2.178.9s1.614-.337 2.177-.9a1.07 1.07 0 0 1 1.495.01 3.041 3.041 0 0 0 2.871.803c1.42-.315 2.373-1.658 2.373-3.11v-.054h.769v5.417h.39c.444 0 .812.368.812.812a.818.818 0 0 1-.812.813z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon07);
export default __webpack_public_path__ + "static/media/icon-07.7a5e2163fc11e06039ade3cdf1021387.svg";
export { ForwardRef as ReactComponent };